export enum Environment {
  local = 'local',
  staging = 'staging',
  production = 'production',
}

export const isServerRendering = () => typeof window === 'undefined';

export const isProd = (environment: string) =>
  environment === Environment.production;

export const isLocal = (environment: Environment) =>
  environment === Environment.local;
